import React from "react";

import { Row, Col } from 'antd';

import dataemptyImg from '../assets/images/icon-empty-dataempty@3x.png';

export default function NotFound() {


    return (
        <div>
            <Row type="flex" justify="center" align="middle">
                <Col span={24}>
                    <div className="not-found-text-main">
                        <font>此頁面無法取得</font>
                    </div>

                </Col>
                <Col span={24}>
                    <div className="not-found-text-sub">
                        <font>您點擊的連結可能已失效，或頁面已被移除。</font>
                    </div>
                </Col>
                <Col span={24}>
                    <img src={dataemptyImg} className="not-found-img" alt="dataempty" />
                </Col>
            </Row>
        </div>
    );
}